/**
 * The WordPress plugin version on the download page. The zip is published under a versioned name
 * (downloads/wapadesk-<version>.zip) so Cloudflare's cache can never hand out an older copy;
 * scripts/build-wp-plugin.mjs refuses to build when this differs from wp-plugin/wapadesk.php.
 */
export const WP_PLUGIN_VERSION = "2.0.0";
export const WP_PLUGIN_ZIP = `ege-digital-chat-button-${WP_PLUGIN_VERSION}.zip`;
//# sourceMappingURL=wp-plugin.js.map